<template>
  <div>
    <!-- <object :data="fileData" type="application/pdf"></object> -->
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>

      <el-col :span="20" class="backgroud-gray cs-fullHeight cs-main-right-container">
        <div class="cs-fullHeight cs-contentContainer-right">
          <div class="backgroud-white  cs-contentContainer-right-content cs-fullHeight">
            <div class="cs-finance-accountList-conainter" v-show="!isShowAccountProfile">
              <el-row>
                <el-col :span="24">
                  <el-row>
                    <el-col>
                      <span class="cs-title">账目表</span>
                    </el-col>
                  </el-row>
                  <div v-loading="loadingSummary">
                    <el-row>
                      <el-col>
                        <span class="cs-totalAmount">{{ totalAmount | toCurrency }}</span>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="24">
                        <div class="cs-finance-amount">
                          <span class="cs-grey">{{ selectedEmployeeName }}收款</span>
                          <span class="cs-grey">待核对: {{ totalAmountUnchecked | toCurrency }}</span>
                          <span class="cs-grey">已核对: {{ totalAmountChecked | toCurrency }}</span>
                          <span class="cs-grey">手续费: {{ totalServiceCharge | toCurrency }}</span>
                          <span class="cs-grey">付款税费: {{ totalTax | toCurrency }}</span>
                          <span class="cs-grey">占位税费: {{ totalAdvanceEnrollmentPriceTax | toCurrency }}</span>
                          <span class="cs-grey">余额税费: {{ totalBalanceCostTax | toCurrency }}
                            (
                            <span class="cs-finance-balance-detail">新余额:{{totalNewBalanceCostTax | toCurrency}},&nbsp;</span>
                            <span class="cs-finance-balance-detail">赠送余额:{{totalGiftBalanceCostTax | toCurrency}}</span>
                            <span  class="cs-finance-balance-detail" v-if="totalOldBalanceCostTax > 0">,&nbsp;旧余额:{{totalOldBalanceCostTax | toCurrency}}</span>
                            )
                          </span>
                        </div>
                        <div class="cs-finance-amount">
                          <span class="cs-grey">总欠款: {{ totalDebt | toCurrency }}</span>
                          <span class="cs-grey">使用总积分: {{ totalBonusPoint }}</span>
                          <span class="cs-grey">使用总余额: {{ totalBalanceCost }}
                            (
                            <span class="cs-finance-balance-detail">新余额:{{totalNewBalanceCost | toCurrency}},&nbsp;</span>
                            <span class="cs-finance-balance-detail">赠送余额:{{totalGiftBalanceCost | toCurrency}}</span>
                            <span class="cs-finance-balance-detail" v-if="totalOldBalanceCost > 0">,&nbsp;旧余额:{{totalOldBalanceCost | toCurrency}}</span>
                            )
                          </span>
                          <span class="cs-blue cs-accountList-viewDetail" @click="viewDetails">
                            查看明细
                            <i class="fa fa-chevron-down" v-if="!isShowPaymentDetails" aria-hidden="true"></i>
                            <i class="fa fa-chevron-up" v-if="isShowPaymentDetails" aria-hidden="true"></i>
                          </span>
                        </div>
                        <paymentDetails v-if="isShowPaymentDetails" v-loading="loadingDetails"
                          :details="paymentDetailList"></paymentDetails>
                      </el-col>
                    </el-row>
                  </div>
                  <el-row class="cs-accountList-topbar">
                    <el-col :span="4" class="cs-accountList-checkPayment">
                      <el-input placeholder="搜索备注" size="medium" clearable suffix-icon="el-icon-search"
                        v-model="searchComment" @keyup.enter.native="onSearchCommentChanged"> </el-input>
                    </el-col>
                    <el-col :span="4" class="cs-accountList-checkPayment cs-accountList-padding">
                      <el-input placeholder="按号码搜索" size="medium" clearable suffix-icon="el-icon-search"
                        v-model.trim="searchPhone" @keyup.enter.native="onSearchConditionChanged(true)"> </el-input>
                    </el-col>
                    <el-col :span="6" class="cs-accountList-padding">
                      <el-date-picker class="cs-accountList-searchDate" v-model="searchDate" type="daterange"
                        align="center" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                        :picker-options="pickerOptions" size="medium" :clearable="false"></el-date-picker>
                    </el-col>
                    <el-col v-if="!USERMANAGER.isFrontDesk && !USERMANAGER.isInternationalSales" :span="4" class="cs-accountList-padding">
                      <el-select placeholder="请选择" v-model="selectedEmployeeId" @change="onEmployeeChange" size="medium"
                        filterable>
                        <el-option v-for="item in employeeListData" :key="item.Id" :label="item.Name" :value="item.Id">
                        </el-option>
                      </el-select>
                    </el-col>

                    <el-col :span="6" class="cs-accountList-checkPayment">
                      <div v-if="!(USERMANAGER.isFinancial || USERMANAGER.isAdmin)">
                        &nbsp;
                      </div>
                      <div v-if="USERMANAGER.isFinancial || USERMANAGER.isAdmin">
                        <el-button :type="paymentCheckBtnClass" v-if="!paginationStatus.isChecking" size="medium"
                          @click="checkPayment">开始核对</el-button>
                        <el-button class="" type="primary" v-if="paginationStatus.isChecking" size="medium"
                          @click="cancelCheckPayment">取消</el-button>
                        <el-button type="primary" v-if="paginationStatus.isChecking" :disabled="isSavingPaymentCheck"
                          size="medium" @click="saveCheckPayment">保存</el-button>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <el-select placeholder="请选择" v-model="selectedCategory" size="medium">
                        <el-option v-for="item in categoryList" :key="item.key" :label="item.value" :value="item.key">
                        </el-option>
                      </el-select>
                    </el-col>
                    <div>
                      <el-col :span="4" class="cs-accountList-padding">
                        <el-select placeholder="请选择" v-model="selectedStudentType" size="medium">
                          <el-option v-for="item in studentTypeList" :key="item.key" :label="item.value"
                            :value="item.key">
                          </el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="4" class="cs-accountList-padding">
                        <el-select placeholder="请选择" v-model="selectedUniversity" size="medium" @change="onUniverstityChange">
                          <el-option v-for="item in universityList" :key="item.key" :label="item.value"
                            :value="item.key">
                          </el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="4" class="cs-accountList-padding">
                        <el-select placeholder="请选择" v-model="selectedAccountType" size="medium">
                          <el-option v-for="item in accountTypeList" :key="item.key" :label="item.value"
                            :value="item.key">
                          </el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="4" class="cs-accountList-padding">
                        <div v-if="![9, 10, 18].contains(selectedAccountType)">&nbsp;</div>
                        <el-select v-if="selectedAccountType == 18" placeholder="业务"
                          v-model="selectedNewStudentGuideCategory" size="medium">
                          <el-option v-for="item in newStudentGuideCategoryList" :key="item.Id" :label="item.Name"
                            :value="item.Id"></el-option>
                        </el-select>
                        <el-select v-if="selectedAccountType == 10" placeholder="业务" v-model="selectedEnglishCategory"
                          size="medium">
                          <el-option v-for="item in englishCategoryList" :key="item.Id" :label="item.Name"
                            :value="item.Id"></el-option>
                        </el-select>
                        <el-select v-if="selectedAccountType == 9" placeholder="业务" v-model="selectedTrainingCategory"
                          size="medium">
                          <el-option v-for="item in trainingCategoryList" :key="item.Id" :label="item.Name"
                            :value="item.Id"></el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="4" class="cs-accountList-checkPayment">
                        <el-button type="primary" size="medium" @click="onSearchConditionChanged(true)">搜索</el-button>
                      </el-col>
                    </div>
                  </el-row>
                  <el-row class="cs-accountList-bottombar">
                    <el-col :span="4">
                      <el-select v-if="selectedAccountType === 1 || selectedAccountType === 2 || selectedAccountType === 18" placeholder="推荐人" v-model="selectedIntroducer"
                        size="medium">
                        <el-option v-for="item in introducers" :key="item.Id" :label="item.Name"
                          :value="item.Id"></el-option>
                      </el-select>
                    </el-col>
                  </el-row> 
                  <el-row class="grid-content">
                    <el-col>
                      <pagination :status="paginationStatus" v-loading="loading" :data="listData"
                        :option="paginationOption" @search="search" @edit="showAccountProfile"
                        @searchWithOption="searchWithOption" @loadData="onLoadAccountList"
                        @pageSizeChange="pageSizeChange" @currentPageChange="currentPageChange"></pagination>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
            <div class="cs-finance-accountProfile-conainter" v-show="isShowAccountProfile">
              <aef-account-profile v-if="accountProfileType === 0" :data="dataForAccountProfile"
                @close="closeAccountProfile" />
              <cef-account-profile v-if="accountProfileType === 1" :data="dataForAccountProfile"
                @close="closeAccountProfile" />
              <ocf-account-profile v-if="accountProfileType === 2" :data="dataForAccountProfile"
                @close="closeAccountProfile" />
              <avappInfo v-if="accountProfileType === 3" :dataIn="dataForAvappInfo" @close="closeAccountProfile" />
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style lang="scss" scoped>
.cs-contentContainer {
  .cs-main-right-container {
    .cs-contentContainer-right-content {
      padding: 0px !important;

      .cs-finance-accountList-conainter {
        padding: 40px;

        .cs-accountList-topbar {
          margin-bottom: 10px;
        }

        .cs-accountList-bottombar{
          margin-top: 10px;
        }

        .cs-accountList-padding {
          padding-left: 15px;
        }

        .cs-accountList-checkPayment {
          text-align: right;

          button {
            display: inline-block;
          }
        }

        .cs-totalAmount {
          font-size: 30px;
          font-weight: bold;
        }

        .cs-finance-amount {
          padding-bottom: 10px;


          &:last-of-type {
            border-bottom: 1px solid #ced3d9;
            margin-bottom: 10px;
          }

          .cs-grey {
            color: grey;
          }

          .cs-blue {
            color: #006ab4;
          }

          .cs-accountList-viewDetail {
            cursor: pointer;
          }

          span {
            display: inline-block;
            margin-right: 20px;
            width: auto;
          }

          .cs-finance-balance-detail{
            margin-right: 0px;
          }

          .fa {
            margin-left: 3px;
          }
        }

        .cs-accountList-searchDate {
          width: auto;

          .el-range-separator {
            z-index: 99;
          }
        }
      }
    }
  }
}
</style>

<script>
import { setStore, getStore, removeStore } from "../../config/mUtils";
import global_ from "../../core/global";
import {
  getUniversityDataList,
  getIntroducers,
  getTrainingCategoryList
} from "../../service/common.service";
import navigator from "../../components/navigator";
import pagination from "../../components/common/pagination";
import paymentDetails from "../../components/finance/paymentDetails";
import aefAccountProfile from "../../components/finance/aefAccountProfile";
import cefAccountProfile from "../../components/finance/cefAccountProfile";
import ocfAccountProfile from "../../components/finance/ocfAccountProfile";
import avappInfo from "../../components/addVideoAppointment/avappInfo";

import {
  getAccountList,
  getAccountListSummary,
  checkPayment,
  getPaymentDetails,
  resetAccountHighlight
} from "../../service/finance.service";
import { getEmployees } from "../../service/user.service";
import { addMonth, formatDate } from "../../config/mUtils.js";

export default {
  data() {
    return {
      fileData: "",
      selectedUniversity: "",
      universityDataList: [],
      universityList: [],
      selectedAccountType: "",
      accountTypeList: [],
      loading: false,
      loadingSummary: false,
      loadingDetails: false,
      listData: {},
      originalListData: {},
      pageSize: 20,
      paginationOption: {},
      paginationStatus: {
        isChecking: false
      },
      paymentCheckBtnClass: "primary",
      isSavingPaymentCheck: false,
      totalAmount: 0,
      totalAmountChecked: 0,
      totalTax: 0,
      totalServiceCharge: 0,
      totalAmountUnchecked: 0,
      totalDebt: 0,
      totalBonusPoint: 0,
      totalBalanceCost: 0,
      totalBalanceCostTax: 0,
      totalNewBalanceCost: 0,
      totalGiftBalanceCost: 0,
      totalOldBalanceCost: 0,
      totalNewBalanceCostTax: 0,
      totalGiftBalanceCostTax: 0,
      totalOldBalanceCostTax: 0,
      totalAdvanceEnrollmentPriceTax: 0,
      employeeListData: [],
      selectedEmployeeName: "所有行政人员",
      selectedEmployeeId: "",
      searchDate: "",
      searchPhone: "",
      searchComment: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      isShowAccountProfile: false,
      accountProfileType: 0,
      dataForAccountProfile: {
        account: null
      },
      dataForAvappInfo: {
        id: 0,
        isView: true
      },
      categoryList: [],
      studentTypeList: [],
      selectedCategory: "",
      selectedStudentType: "",
      selectedTrainingCategory: "",
      selectedEnglishCategory: "",
      selectedNewStudentGuideCategory: "",
      selectedIntroducer: "",

      paymentDetailList: [],
      isReloadDetails: false,
      isShowPaymentDetails: false,
      paymentCheckChangeList: [],
      accountCheckChangeList: [],
      trainingCategoryList: [],
      englishCategoryList: [],
      newStudentGuideCategoryList: [],
      allIntroducers:[],
      introducers:[],
    };
  },
  components: {
    navigator,
    pagination,
    paymentDetails,
    aefAccountProfile,
    cefAccountProfile,
    ocfAccountProfile,
    avappInfo,
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    async init() {
      this.categoryList = [];
      this.categoryList.push({ key: 1, value: "所有类" });
      this.categoryList.push({ key: 2, value: "只显示欠款类" });
      this.categoryList.push({ key: 3, value: "只显示待处理" });
      this.categoryList.push({ key: 4, value: "只显示已核对" });
      this.categoryList.push({ key: 5, value: "只显示标红价" });
      this.selectedCategory = 1;

      this.studentTypeList = [];
      this.studentTypeList.push({ key: 1, value: "所有学生" });
      this.studentTypeList.push({ key: 2, value: "只显示新生" });
      this.studentTypeList.push({ key: 3, value: "只显示老生" });
      this.selectedStudentType = 1;

      this.accountTypeList = [];
      if (this.USERMANAGER.isVocationalTrainingManager){
        this.accountTypeList.push({ key: 8, value: "只显示职业培训占位" });
        this.accountTypeList.push({ key: 9, value: "只显示职业培训报名" });
        this.selectedAccountType = 9;
      }else{
        this.accountTypeList.push({ key: 0, value: "所有收款类型" });
        if (!this.USERMANAGER.isInternationalSales){
          this.accountTypeList.push({ key: 1, value: "只显示大学占位" });
        }
      
        this.accountTypeList.push({ key: 2, value: "只显示大学报名" });
        this.accountTypeList.push({ key: 3, value: "只显示会员" });
        if (!this.USERMANAGER.isInternationalSales){
          this.accountTypeList.push({ key: 8, value: "只显示职业培训占位" });
        }
        
        this.accountTypeList.push({ key: 9, value: "只显示职业培训报名" });
        this.accountTypeList.push({ key: 10, value: "只显示应试英语培训报名" });
        this.accountTypeList.push({ key: 18, value: "只显示新生引流报名" });
        this.accountTypeList.push({ key: 11, value: "只显示余额充值" });
        //this.accountTypeList.push({ key: 5, value: "只显示看视频" });
        this.accountTypeList.push({ key: 7, value: "只显示学业规划" });
        this.accountTypeList.push({ key: 12, value: "只显示看视频" });
        this.accountTypeList.push({ key: 20, value: "只显示视频包" });
        this.accountTypeList.push({ key: 21, value: "只显示刷课" });
        this.selectedAccountType = 0;
      }

      this.searchDate = [];
      let today = new Date();
      //let lastMonthDate = addMonth(today, -1);
      //this.searchDate.push(lastMonthDate);
      this.searchDate.push(today);
      this.searchDate.push(today);

      getTrainingCategoryList(3).then(result => {
        if (!!result && result.success) {
          this.trainingCategoryList = result.data;
          this.trainingCategoryList.splice(0, 0, {
            Id: 0,
            Name: "所有业务"
          });
        }
        this.selectedTrainingCategory = 0;
      });

      getTrainingCategoryList(2).then(result => {
        if (!!result && result.success) {
          this.englishCategoryList = result.data;
          this.englishCategoryList.splice(0, 0, {
            Id: 0,
            Name: "所有业务"
          });
        }
        this.selectedEnglishCategory = 0;
      });

      getTrainingCategoryList(4).then(result => {
        if (!!result && result.success) {
          this.newStudentGuideCategoryList = result.data;
          this.newStudentGuideCategoryList.splice(0, 0, {
            Id: 0,
            Name: "所有业务"
          });
        }
        this.selectedNewStudentGuideCategory = 0;
      });

      getIntroducers().then(result =>{
        if (!!result && result.success){
          this.allIntroducers = result.data;
        }
      });

      await this.getEmployeeListData();
      await this.getPaymentDetailsData();
      await this.loadUniversityList();
      this.loadIntroducers();
      this.paginationOption = {
        displayPagination: true,
        hasEditButton: true,
        editButtonText: "查看详情",
        buttonWidth:"100",
        hasAddButton: false,
        hasSearch: false,
        hasDateSearch: false,
        fixedAction: 'right'
      };

      this.search();
    },
    async loadUniversityList() {
      this.universityList = [];
      this.universityList.push({ key: 0, value: "所有学校" });
      let result = await getUniversityDataList(true);
      if (!!result && result.success) {
        this.universityDataList = result.data;
        result.data.forEach(i => {
          this.universityList.push({ key: i.Id, value: i.Abbreviation });
        });
      }
      this.selectedUniversity = 0;
    },
    viewDetails() {
      this.isShowPaymentDetails = !this.isShowPaymentDetails;
      if (this.isShowPaymentDetails && this.isReloadDetails) {
        this.getPaymentDetailsData();
      }
    },
    checkReloadDetials() {
      if (this.isShowPaymentDetails) {
        this.getPaymentDetailsData();
      } else {
        this.isReloadDetails = true;
      }
    },
    async getPaymentDetailsData() {
      this.isReloadDetails = false;
      this.loadingDetails = true;
      let pageData = this.getSearchPageData();
      await getPaymentDetails(pageData)
        .then(result => {
          if (result && result.success) {
            this.paymentDetailList = result.data;
          }
          this.loadingDetails = false;
        })
        .catch(error => {
          console.log(error);
          this.loadingDetails = false;
        });
    },
    saveCheckPayment() {
      if (this.isSavingPaymentCheck) {
        return;
      }

      this.getPaymentCheckChangeList();
      let paymentCheckList = [];
      this.paymentCheckChangeList.forEach(element => {
        let paymentCheck = this.getPaymentCheck(element);
        if (!!paymentCheck) {
          paymentCheckList.push(paymentCheck);
        }
      });
      this.isSavingPaymentCheck = true;
      checkPayment(paymentCheckList, this.accountCheckChangeList).then(
        result => {
          this.isSavingPaymentCheck = false;
          if (result.success) {
            this.$message({
              message: "保存核对成功",
              type: "success"
            });
            this.checkReloadDetials();
            this.updateTotalAmount();
            this.originalListData = JSON.parse(JSON.stringify(this.listData));
            if (this.accountCheckChangeList.length > 0) {
              this.search();
            }

            this.paymentCheckChangeList = [];
            this.accountCheckChangeList = [];
          } else {
            this.$message({
              message: result.message,
              type: "error"
            });
          }
          this.paginationOption.hasEditButton = true;
        }
      );
      this.$set(this.paginationStatus, "isChecking", false);
      this.paymentCheckBtnClass = "primary";
    },
    updateTotalAmount() {
      let uncheckedAmountChange = 0;
      let checkedAmountChange = 0;
      this.paymentCheckChangeList.forEach(element => {
        if (element.IsChecked) {
          checkedAmountChange += element.Amount;
        } else {
          uncheckedAmountChange += element.Amount;
        }
      });
      this.totalAmountChecked += checkedAmountChange - uncheckedAmountChange;
      this.totalAmountUnchecked += uncheckedAmountChange - checkedAmountChange;
    },
    cancelCheckPayment() {
      this.paymentCheckChangeList = [];
      this.accountCheckChangeList = [];
      this.$set(this.paginationStatus, "isChecking", false);
      this.paymentCheckBtnClass = "primary";
      this.listData = JSON.parse(JSON.stringify(this.originalListData));
      this.paginationOption.hasEditButton = true;
    },
    checkPayment() {
      this.paymentCheckChangeList = [];
      this.accountCheckChangeList = [];
      this.$set(this.paginationStatus, "isChecking", true);
      this.paymentCheckBtnClass = "info";
      this.paginationOption.hasEditButton = false;
    },
    getPaymentCheck(accountPayment) {
      if (!accountPayment) {
        return false;
      }
      if (!accountPayment.Id) {
        return false;
      }

      let paymentCheckData = {
        Key: accountPayment.Id,
        Value: accountPayment.IsChecked
      };
      return paymentCheckData;
    },
    onSearchConditionChanged(isSearch) {
      if (isSearch) {
        this.search();
        this.checkReloadDetials();
      }
    },
    onLoadAccountList(pageData) {
      this.search(pageData.pageNumber, true);
    },
    onEmployeeChange() {
      let emp = this.employeeListData.filter(
        i => i.Id == this.selectedEmployeeId
      );
      if (!!emp && emp.length > 0) {
        this.selectedEmployeeName = emp[0].Name;
      }
      //this.search();
      //this.checkReloadDetials();
    },
    async getEmployeeListData() {
      let list = this.GLOBAL.roleType.getOptionsByKeys([
        "sales",
        "assistant",
        "receptionist",
        "executiveManager",
        "financialManager",
        "financialAssistant",
        "financialAccounting",
        "vocationalTrainingManager",
      ]);
      if (this.USERMANAGER.isAdmin || this.USERMANAGER.isFinancial) {
        list.push(this.GLOBAL.roleType.keyOf("internationalSales"));
      } else if (this.USERMANAGER.isInternationalSales){
        list = [this.GLOBAL.roleType.keyOf("internationalSales")];
      }
      let roleTypes = list.map(enumOption => enumOption.value);
      let result = await getEmployees(roleTypes, "", null);
      if (result && result.success) {
        this.employeeListData = result.data.Results.map(i => {
          return { Id: i.UserId, Name: i.Name };
        });
        this.employeeListData.splice(0, 0, { Id: 0, Name: "所有行政人员" });
      } else {
        this.employeeListData = [];
        this.employeeListData.push({ Id: 0, Name: "所有行政人员" });
      }
      this.selectedEmployeeId = 0;
    },
    getSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      let startDate = "";
      let endDate = "";
      if (!!this.searchDate && this.searchDate.length == 2) {
        startDate = formatDate(this.searchDate[0]);
        endDate = formatDate(this.searchDate[1]);
      }
      let courseCategory = "";
      if (this.selectedAccountType == 9) {
        courseCategory = this.selectedTrainingCategory;
      } else if (this.selectedAccountType == 10) {
        courseCategory = this.selectedEnglishCategory;
      } else if (this.selectedAccountType == 18) {
        courseCategory = this.selectedNewStudentGuideCategory;
      }
      let filterList = {
        EmployeeId: [this.selectedEmployeeId],
        Category: [this.selectedCategory],
        StudentType: [this.selectedStudentType],
        University: [this.selectedUniversity],
        AccountType: [this.selectedAccountType],
        Comment: [this.searchComment],
        CourseCategory: [courseCategory],
        Introducer: [this.selectedIntroducer],
      };

      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        keyWord: this.searchPhone,
        startDate: startDate,
        endDate: endDate,
        filterList: filterList
      };
      return pageData;
    },
    searchWithOption(option) { },
    search(pageNumber, ignoreSummary) {
      let pageData = this.getSearchPageData(pageNumber);
      if (!pageData.startDate || !pageData.endDate) {
        this.$warrning("请输入有效的日期范围");
        return;
      }
      this.loadAccountListData(pageData);
      if (!ignoreSummary){
        this.loadAccountListSummaryData(pageData);
      }
      
    },
    setAccountProfileType(account) {
      if (!!account) {
        switch (account.AccountType) {
          case this.GLOBAL.accountType.signClass:
          case this.GLOBAL.accountType.trainingSignClass:
          case this.GLOBAL.accountType.englishSignClass:
          case this.GLOBAL.accountType.newStudentGuideSignClass:
            this.accountProfileType = 1;
            break;
          case this.GLOBAL.accountType.memberCard:
          case this.GLOBAL.accountType.renewMemberCard:
          case this.GLOBAL.accountType.watchVideos:
          case this.GLOBAL.accountType.bonusPointExchangeItem:
          case this.GLOBAL.accountType.academicPlanning:
          case this.GLOBAL.accountType.airportPickUp:
          case this.GLOBAL.accountType.videoPackage:
          case this.GLOBAL.accountType.topUpBalance:
          case this.GLOBAL.accountType.extendMemberCard:
          case this.GLOBAL.accountType.autoEnrollCourse:
            this.accountProfileType = 2;
            break;
          case this.GLOBAL.accountType.videoAppointment:
          case this.GLOBAL.accountType.videoAppointmentDeposit: {
            this.accountProfileType = 3;
            break;
          }
          case this.GLOBAL.accountType.studyAbroad: {
            this.accountProfileType = 4;
            break;
          }
          default:
            this.accountProfileType = 0;
            break;
        }
      } else {
        this.accountProfileType = 0;
      }
    },
    reloadAccountProfileData(account) {
      switch (this.accountProfileType) {
        case 3: {
          let newData = {
            id: account.WorkflowId,
            isView: true
          };

          this.dataForAvappInfo = newData;
          break;
        }
        default: {
          let newData = {
            account: account
          };

          this.dataForAccountProfile = newData;
          break;
        }
      }
    },
    checkIsHighlight(row) {
      if (row.IsHighlight) {
        resetAccountHighlight(row.Id).then(result => {
          if (!!result && result.success) {
            row.IsHighlight = false;
          }
        });
      }
    },
    showAccountProfile(index, row) {
      this.setAccountProfileType(row);
      this.reloadAccountProfileData(row);
      this.checkIsHighlight(row);
      this.isShowAccountProfile = true;
    },
    closeAccountProfile(isReload) {
      this.isShowAccountProfile = false;
      if (isReload) {
        this.search(this.listData.CurrentPage);
      }
    },
    pageSizeChange(value) {
      // if (this.isDataChange()){
      //   return;
      // }
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    getPaymentCheckChangeList() {
      let length = this.listData.Results.length;
      for (let i = 0; i < length; i++) {
        let item = this.listData.Results[i];
        let itemOriginal = this.originalListData.Results[i];

        if (!!item.AccountPayment1) {
          if (!item.AccountPayment1.Id) {
            if (item.AccountPayment1.IsChecked) {
              if (this.accountCheckChangeList.indexOf(item.Id) < 0) {
                this.accountCheckChangeList.push(item.Id);
              }
            }
          } else {
            this.addPaymentCheckChangeListItem(
              item.AccountPayment1,
              itemOriginal.AccountPayment1
            );
            this.addPaymentCheckChangeListItem(
              item.AccountPayment2,
              itemOriginal.AccountPayment2
            );
            this.addPaymentCheckChangeListItem(
              item.AccountPayment3,
              itemOriginal.AccountPayment3
            );
          }
        }
      }
    },
    addPaymentCheckChangeListItem(accountPayment, accountPaymentOriginal) {
      if (!accountPayment || !accountPaymentOriginal) {
        return;
      }
      if (accountPayment.IsChecked != accountPaymentOriginal.IsChecked) {
        let index = this.paymentCheckChangeList.findIndex(i => {
          if (i.Id == accountPayment.Id) {
            return true;
          } else {
            return false;
          }
        });
        if (index < 0) {
          this.paymentCheckChangeList.push(accountPayment);
        }
      }
    },
    loadAccountListData(pageData) {
      this.loading = true;

      getAccountList(pageData)
        .then(result => {
          if (result && result.success) {
            this.listData = result.data;
            this.originalListData = JSON.parse(JSON.stringify(this.listData));
            /*this.totalAmount = this.listData.AdditionalResult.totalAmount;
            this.totalAmountChecked = this.listData.AdditionalResult.totalAmountChecked;
            this.totalTax = this.listData.AdditionalResult.totalTax;
            this.totalServiceCharge = this.listData.AdditionalResult.totalServiceCharge;
            this.totalAmountUnchecked = this.listData.AdditionalResult.totalAmountUnchecked;
            this.totalDebt = this.listData.AdditionalResult.totalDebt;
            this.totalBonusPoint = this.listData.AdditionalResult.totalBonusPoint;
            this.totalBalanceCost = this.listData.AdditionalResult.totalBalanceCost;
            this.totalBalanceCostTax = this.listData.AdditionalResult.totalBalanceCostTax;
            this.totalAdvanceEnrollmentPriceTax = this.listData.AdditionalResult.totalAdvanceEnrollmentPriceTax;*/
          }
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
        });
    },
    loadAccountListSummaryData(pageData) {
      this.loadingSummary = true;
      getAccountListSummary(pageData)
        .then(result => {
          if (result && result.success) {
            this.totalAmount = result.data.TotalAmount;
            this.totalAmountChecked = result.data.TotalAmountChecked;
            this.totalTax = result.data.TotalTax;
            this.totalServiceCharge = result.data.TotalServiceCharge;
            this.totalAmountUnchecked = result.data.TotalAmountUnchecked;
            this.totalDebt = result.data.TotalDebt;
            this.totalBonusPoint = result.data.TotalBonusPoint;
            this.totalBalanceCost = result.data.TotalBalanceCost;
            this.totalBalanceCostTax = result.data.TotalBalanceCostTax;
            this.totalNewBalanceCost = result.data.TotalNewBalanceCost;
            this.totalGiftBalanceCost = result.data.TotalGiftBalanceCost;
            this.totalOldBalanceCost = result.data.TotalOldBalanceCost;
            this.totalNewBalanceCostTax = result.data.TotalNewBalanceCostTax;
            this.totalGiftBalanceCostTax = result.data.TotalGiftBalanceCostTax;
            this.totalOldBalanceCostTax = result.data.TotalOldBalanceCostTax;
            this.totalAdvanceEnrollmentPriceTax = result.data.TotalAdvanceEnrollmentPriceTax;
          }
          this.loadingSummary = false;
        })
        .catch(error => {
          console.log(error);
          this.loadingSummary = false;
        });
    },
    loadIntroducers(){
      let introducers = [];
      let university = this.universityDataList.find(i => i.Id === this.selectedUniversity);
      if (university && university.GroupNumber && this.allIntroducers){
        introducers = this.allIntroducers.filter(i => i.UniversityGroup === university.GroupNumber);
      }
      introducers.splice(0, 0, {Id: 0, Name: "所有推荐人"});
      this.introducers = introducers;
      this.selectedIntroducer = 0;
    },
    onUniverstityChange(){
      this.loadIntroducers();
    }
  },
  watch: {}
};
</script>
 



// WEBPACK FOOTER //
// src/page/finance/accountList.vue